import axios from 'axios';
import { ENDPOINTS } from './endpoints';

export const getStakeholderRequestTypes = async () => {
  try {
    const response = await axios.get(ENDPOINTS.STAKEHOLDER_REQUEST_TYPE.GET);
    return response.data; // Assuming the API returns the list of users directly
  } catch (error) {
    // Handle errors or re-throw them
    throw error;
  }
};

export const getStakeholderRequestTypeById = async (id) => {
  try {
    const response = await axios.get(`${ENDPOINTS.STAKEHOLDER_REQUEST_TYPE.GET_BY_ID}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createStakeholderRequestType = async (data) => {
  try {
    const response = await axios.post(ENDPOINTS.STAKEHOLDER_REQUEST_TYPE.CREATE, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateStakeholderRequestType = async (id, data) => {
  try {
    const response = await axios.put(`${ENDPOINTS.STAKEHOLDER_REQUEST_TYPE.UPDATE}/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteStakeholderRequestType = async (id) => {
  try {
    const response = await axios.delete(`${ENDPOINTS.STAKEHOLDER_REQUEST_TYPE.DELETE}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};
